module.exports = __webpack_public_path__ + "img/favicon.6591c676.png";